import { render, staticRenderFns } from "./PhotosView.vue?vue&type=template&id=42afe824&scoped=true&"
import script from "./PhotosView.vue?vue&type=script&lang=js&"
export * from "./PhotosView.vue?vue&type=script&lang=js&"
import style0 from "./PhotosView.vue?vue&type=style&index=0&id=42afe824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afe824",
  null
  
)

export default component.exports